var map = {
	"./image1.png": 17394,
	"./image10.png": 14984,
	"./image2.png": 8105,
	"./image3.png": 36928,
	"./image4.png": 88255,
	"./image5.png": 91926,
	"./image6.png": 73549,
	"./image7.png": 33604,
	"./image8.png": 91267,
	"./image9.png": 67661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97218;